import { useRef } from 'react';
import { useVirtualList } from '../../../hooks/useVirtualList';
export function useTableVirtualList(rowsCount, externalScrollRef) {
    const tableVirtualListResult = useVirtualList(rowsCount, () => 32, externalScrollRef);
    const tableHeadRef = useRef(null);
    const tableBodyRef = useRef(null);
    const tableFootRef = useRef(null);
    const getTableBodyStyle = () => {
        var _a, _b, _c, _d;
        const virtualListStyle = tableVirtualListResult.getVirtualListStyle();
        const viewportHeight = tableVirtualListResult.getViewportHeight();
        const tableHeadHeight = (_b = (_a = tableHeadRef.current) === null || _a === void 0 ? void 0 : _a.offsetHeight) !== null && _b !== void 0 ? _b : 0;
        const tableFootHeight = (_d = (_c = tableFootRef.current) === null || _c === void 0 ? void 0 : _c.offsetHeight) !== null && _d !== void 0 ? _d : 0;
        const bodyMinHeight = Math.max(viewportHeight - tableHeadHeight - tableFootHeight, 0);
        return Object.assign(Object.assign({}, virtualListStyle), { minHeight: bodyMinHeight });
    };
    return {
        containerRef: tableVirtualListResult.containerRef,
        tableHeadRef,
        tableBodyRef,
        tableFootRef,
        measureElement: tableVirtualListResult.measureElement,
        getTableBodyStyle,
        getVirtualItemStyle: tableVirtualListResult.getVirtualItemStyle,
        getVirtualList: tableVirtualListResult.getVirtualList
    };
}
